/**
 * Full-page audit recommendations (deep link /qms/recommendations).
 * Used by App.js and AppAuthenticated.js; requires OrgProvider.
 */

import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import RecommendationRegistry from './RecommendationRegistry';
import { useOrg } from '../../hooks/useOrg';

const REC_ROLES = new Set([
  'management',
  'ic_personnel',
  'administration',
  'admin',
  'Management',
  'IC_Personnel',
  'Administration',
  'Admin'
]);

export default function QmsRecommendationsStandalone({ userData, userRole, homePath = '/' }) {
  const { t } = useTranslation(['qms']);
  const { activeOrgId, organizationIds } = useOrg();
  const orgId =
    activeOrgId || (Array.isArray(organizationIds) && organizationIds.length > 0 ? organizationIds[0] : null);

  if (!REC_ROLES.has(userRole)) {
    return <Navigate to={homePath} replace />;
  }

  return (
    <div className="app-layout" style={{ flexDirection: 'column' }}>
      <header
        style={{
          padding: '0.75rem 1rem',
          borderBottom: '1px solid var(--border-color, #e5e7eb)',
          display: 'flex',
          alignItems: 'center',
          gap: '1rem'
        }}
      >
        <Link to={homePath}>← {t('qms:recommendations.backToDashboard')}</Link>
        <span style={{ fontWeight: 600 }}>{t('qms:recommendations.registryTitle')}</span>
      </header>
      <main style={{ flex: 1, overflow: 'auto' }}>
        {!orgId ? (
          <div className="loading-container">
            <p>{t('qms:capa.selectOrganization')}</p>
          </div>
        ) : (
          <RecommendationRegistry
            organizationId={orgId}
            userId={userData?.uid}
            userRole={userRole}
          />
        )}
      </main>
    </div>
  );
}
